import api from '~/services/pluginbot-api';

/**
 * Pré-registro de robô (ex.: mock para desenvolvimento). POST /robots/register.
 *
 * @param {object} payload
 * @param {string} payload.identifier — texto claro (MAC, serial ou string mock); o backend faz o hash.
 * @param {string} [payload.type] — slug do tipo (grupo robot), se não enviar typeId.
 * @param {string} [payload.typeId] — uid do tipo (Type.uid), alternativa a type.
 * @param {object} [payload.settings] — JSON opcional.
 */
export function postRobotRegister(payload) {
    const body = { identifier: payload.identifier };
    if (payload.typeId) {
        body.type_id = payload.typeId;
    } else if (payload.type) {
        body.type = payload.type;
    }
    if (payload.settings != null) {
        body.settings = payload.settings;
    }
    return api.post('robots/register', body);
}
